import type React from 'react';

import { Spinner } from '@change/ds-core-ui/Spinner';

import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import type { PetitionDetailsPagePrefetchedDataProps } from '#src/app/pages/petitionDetails/pageContext';
import { PetitionDetailsPageContextProvider } from '#src/app/pages/petitionDetails/pageContext';

import { DetailsWithContext } from './DetailsWithContext';
import { PetitionDetailsErrorHandler } from './ErrorHandler';

export const CommonPetitionDetails: React.FC<CommonPetitionDetailsProps> = ({ prefetchedData, prefetchedUserData }) => {
	const { slug } = useKnownAvailableParams<{ slug: string }>();

	return (
		<div data-qa="petition-gamma">
			<PetitionDetailsPageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				prefetchedUserData={prefetchedUserData}
				errorHandler={PetitionDetailsErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<DetailsWithContext slug={slug} />
			</PetitionDetailsPageContextProvider>
		</div>
	);
};

type CommonPetitionDetailsProps = PetitionDetailsPagePrefetchedDataProps;
